module.exports = __webpack_public_path__ + "media/images/myimage-299e71517f79f086dfbbca249b60a2a0.png";